import { apiSlice } from "../../app/api/apiSlice";

const provideSiteTags = (result) =>
  result
    ? [
        ...result.map(({ id, _id }) => ({ type: "Site", id: id || _id })),
        { type: "Site", id: "LIST" },
      ]
    : [{ type: "Site", id: "LIST" }];

export const sitesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getSites: builder.query({
      query: () => "/site",
      // keepUnusedDataFor: 5,
      providesTags: provideSiteTags,
    }),
    getProtectedSites: builder.query({
      query: () => "/site/protected",
      providesTags: provideSiteTags,
    }),
    getTrainerSites: builder.query({
      query: () => "/site/trainer-plan",
      keepUnusedDataFor: 30,
      providesTags: provideSiteTags,
    }),
    getSiteDeleteSummary: builder.query({
      query: (id) => `/site/${id}/delete-summary`,
    }),
    addNewSite: builder.mutation({
      query: (site) => ({
        url: "/site",
        method: "POST",
        body: site,
      }),
      // Typically you want to invalidate "LIST" so RTK Query re-fetches your array
      invalidatesTags: [{ type: "Site", id: "LIST" }],
    }),
    updateSite: builder.mutation({
      query: (data) => ({
        url: "/site",
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) =>
        // If you have a single record, you can invalidate it by ID
        [
          { type: "Site", id },
          { type: "Site", id: "LIST" },
        ],
    }),
    updateTrainerAssignments: builder.mutation({
      query: ({ id, trainerAssignments }) => ({
        url: `/site/${id}/trainer-assignments`,
        method: "PATCH",
        body: { trainerAssignments },
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Site", id },
        { type: "Site", id: "LIST" },
      ],
    }),
    upsertTrainerSlot: builder.mutation({
      query: ({ id, ...slotPayload }) => ({
        url: `/site/${id}/trainer-slot`,
        method: "PATCH",
        body: slotPayload,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Site", id },
        { type: "Site", id: "LIST" },
      ],
    }),
    removeTrainerSlot: builder.mutation({
      query: ({ id, ...slotPayload }) => ({
        url: `/site/${id}/trainer-slot`,
        method: "DELETE",
        body: slotPayload,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Site", id },
        { type: "Site", id: "LIST" },
      ],
    }),
    deleteSite: builder.mutation({
      query: (data) => ({
        url: "/site",
        method: "DELETE",
        body: data,
      }),
      invalidatesTags: (result, error, { id }) => [
        { type: "Site", id },
        { type: "Site", id: "LIST" },
      ],
    }),
  }),
});

export const {
  useGetSitesQuery,
  useGetProtectedSitesQuery,
  useGetTrainerSitesQuery,
  useGetSiteDeleteSummaryQuery,
  useAddNewSiteMutation,
  useUpdateSiteMutation,
  useUpdateTrainerAssignmentsMutation,
  useUpsertTrainerSlotMutation,
  useRemoveTrainerSlotMutation,
  useDeleteSiteMutation,
} = sitesApiSlice;
